import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-bg-secondary/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-313" data-mp="2nvnf5h3e3ihq">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-314" data-mp="2sw1n6z4zqsfr">
        <div data-id="element-315" data-mp="2stylhhuh7av7">
          <p className="font-heading text-sm font-semibold text-white" data-id="element-316" data-mp="o0l2gkc3ccjc">13,99€</p>
          <p className="text-[11px] text-muted" data-id="element-317" data-mp="o2xr1gcctl5d">Acceso inmediato</p>
        </div>
        {/* When off-screen (aria-hidden), the link must also drop out of the tab
            order — otherwise keyboard/screen-reader users can focus an
            interactive element that is hidden from assistive tech. */}
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} tabIndex={visible ? undefined : -1} data-id="element-318" data-mp="11xzw619dn6h4">
          Quiero MISTER PRO
        </PrimaryButton>
      </div>
    </div>;
}